import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { Select } from '@lib/components'
import { openModal } from '@storeOld/reducers/ui'
import cx from 'classnames'
import type React from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { SHARE_PERMISSION } from '@/permissions/project/definitions'
import { useProjectAccess } from '../../../../../../../../../../hooks'
import { useGetShareSettingOptions } from '../../hooks/useGetShareOptions'
import { PROJECT_SHARE_TYPE } from '../../types'

type Props = {
  selected: PROJECT_SHARE_TYPE
  onChange: (value: string | number) => void
}

const ShareSettings: React.FC<Props> = ({ selected, onChange }) => {
  const [selectedOption, setSelectedOption] =
    useState<PROJECT_SHARE_TYPE>(selected)

  const dispatch = useDispatch()
  const shareOptions = useGetShareSettingOptions()

  const { hasAccess } = useProjectAccess(
    SHARE_PERMISSION.CHANGE_SHARE_SETTINGS_TYPE
  )

  const handleOnChange = (value: string | number) => {
    const currentOption = shareOptions.find((option) => option.value === value)

    if (!currentOption?.disabled) {
      setSelectedOption(value as PROJECT_SHARE_TYPE)
      onChange(value)
      return
    }

    if (currentOption.badgeType === 'plan_pro') {
      sendGtmEvent(GtmTriggerName.UPGRADE_PASSWORD)

      dispatch(
        openModal({
          modalType: MODAL_UPGRADE_PLAN,
          modalProps: {
            slideType: 'password_protect',
          },
        })
      )
      return
    }

    if (currentOption.badgeType === 'plan_team') {
      sendGtmEvent(GtmTriggerName.UPGRADE_MEMBERS_ONLY)

      dispatch(
        openModal({
          modalType: MODAL_UPGRADE_PLAN,
          modalProps: {
            planType: 'team',
            slideType: 'members',
          },
        })
      )
    }
  }

  const iconClassName = cx('fa', {
    'fa-globe': selectedOption === PROJECT_SHARE_TYPE.ANYONE,
    'fa-user-group': selectedOption === PROJECT_SHARE_TYPE.ONLY_MEMBERS,
    'fa-lock': selectedOption === PROJECT_SHARE_TYPE.PASSWORD,
  })

  return (
    <Select
      options={shareOptions}
      type="select"
      selected={selectedOption}
      disabled={!hasAccess}
      icon={<i className={iconClassName} />}
      onChange={handleOnChange}
      disableScrollIntoView
      listMinWidth={264}
      position="bottom-start"
    />
  )
}

export default ShareSettings
